import { z } from "zod";

const schema = z.object({
  cultureLink: z.string().optional(),
  personalityResults: z.string().optional(),
  personalityDetail: z.string().optional(),
  behaviorResults: z.string().optional(),
  behaviorDetail: z.string().optional(),
  motivatorsResults: z.string().optional(),
  motivatorsDetails: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export {
  schema as candidateApprovalFormSchema,
  type Schema as CandidateApprovalFormSchema,
};
